
export class SubscriptionService {
    constructor() {
        this.subscriptions = new Set();
        this.services = new Set();
    }

    static injectMixin = {
        beforeCreate() { // Must before watch
            this.serviceInjectMixin_services = new Set();
        },
        beforeDestroy() {
            this.serviceInjectMixin_services.forEach(function (service) {
                if (service && service.destroy) {
                    service.destroy();
                }
            });
        }
    }

    destroy() {
        this.services.forEach(function (service) {
            if (service && service.destroy) {
                service.destroy();
            }
        });
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    }
}
